<template>
  <div class="t_header">
    <img src="@/assets/img/logo/logoin.png" style="height: 28px" alt="">
    <div class="t_head_right">
      <div v-if="sjLxdh!=''" style="margin-right: 20px;">
        <img
          src="@/assets/img/shouyedianhua.png"
          style="
                  float:left;
                  height: 20px;
                  margin-left: 20px;
                  margin-right: 6px;
                  margin-top: 2px;
                "
        >
        <div style="float: right;font-weight: bolder;">服务电话：{{ sjLxdh }}</div>
      </div>

      <img
        :src="userinfo.avatar"
        style="width: 55px; margin-right: 15px; border-radius: 50%"
        alt=""
      >
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          <i class="el-icon-user" /> 欢迎您！{{ userinfo.name
          }}<i class="el-icon-arrow-down el-icon--right" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item @click.native="changepwd">
                修改密码
              </el-dropdown-item> -->
          <el-dropdown-item
            v-if="issuccess"
            @click.native="$router.push('/personalCenter')"
          >
            个人中心
          </el-dropdown-item>
          <el-dropdown-item v-else @click.native="removeUser">
            注销账号
          </el-dropdown-item>
          <el-dropdown-item @click.native="outlogin">
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
// 获取接口地址
import { returnShowPic } from '@/assets/js/common.js'
import { getUserInfo, logout, removeUser } from '@/assets/js/login'
import { isEmpty, removeToken, setFrameDisplay } from '@/utils/tool'
export default {
  name: 'Header',
  data() {
    return {
      sjLxdh: '',
      userinfo: {
        name: '',
        avatar: require('@/assets/img/userimg.png')
      },
      issuccess: false
    }
  },
  created() {
    this.getuserinfo()
    // 判断单位审核状态
    this.checktype()
  },
  mounted() {
    this.$bus.on('getSjLxdh', (val) => {
      if (!isEmpty(val)) {
        this.sjLxdh = val
      }
    })
  },
  beforeDestroy() {
    this.$bus.$off('getSjLxdh')
  },
  methods: {
    getuserinfo() {
      getUserInfo().then((e) => {
        if (isEmpty(e.data.data.avatar)) {
          this.userinfo.avatar = require('@/assets/img/userimg.png')
          this.userinfo.name = e.data.data.name
        } else {
          this.userinfo.avatar =
            returnShowPic() + e.data.data.avatar
          this.userinfo.name = e.data.data.name
        }
        setFrameDisplay(e.data.data.dsfLy == null)
      })
    },
    removeUser() {
      this.$confirm('注销账号，账号将不能使用, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 注销用户
        removeUser().then((e) => {
          removeToken()
          this.$router.push('/login')
        })
      })
    },
    // 退出登录
    outlogin() {
      logout().then((e) => {
        removeToken()
        this.$router.push('/login')
      })
    },
    // 判断单位审核状态
    checktype() {
      if (this.$cookies.get('isInit') == 'false') {
        // 申请通过
        this.issuccess = true
      }
    }
  }
}
</script>

<style scoped>
.t_header {
  text-align: center;
  display: flex;
  justify-content: space-between;
  background-color: white;
  height: 86px;
  align-items: center;
  padding: 0 40px;
  border-bottom: 1px solid #dddddd;
}

.el-dropdown-link {
  cursor: pointer;
  /* color: white; */
}
.el-icon-arrow-down {
  font-size: 12px;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
.t_head_right {
  display: flex;
  align-items: center;
}
</style>
